(() => {
  let activeToggle, heroObserver, fixedHeader, headerFrame = 0;
  const menu = document.querySelector('.menu-dialog');
  const bottomNav = document.querySelector('.bottom-nav');
  const closeMenu = () => { if (menu?.open) menu.close(); };
  const updateFixedHeader = () => fixedHeader?.classList.toggle('is-scrolled', window.scrollY > 12);
  window.addEventListener('scroll', () => {
    if (!headerFrame) headerFrame = requestAnimationFrame(() => { headerFrame = 0; updateFixedHeader(); });
  }, {passive:true});
  document.addEventListener('click', event => {
    const toggle = event.target.closest('.menu-toggle');
    if (toggle && menu) { activeToggle = toggle; menu.showModal(); toggle.setAttribute('aria-expanded','true'); document.body.style.overflow='hidden'; }
    if (event.target.closest('.menu-close, .menu-dialog a')) closeMenu();
  });
  menu?.addEventListener('close', () => { document.body.style.overflow=''; activeToggle?.setAttribute('aria-expanded','false'); activeToggle?.focus({preventScroll:true}); });
  menu?.addEventListener('click',event => { if(event.target===menu){const r=menu.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)closeMenu();} });
  function setupSections() {
    heroObserver?.disconnect();
    const landing = document.querySelector('.landing');
    const site = document.querySelector('.kk-site');
    const homeHeader = landing?.querySelector('.landing-bar');
    if (site && homeHeader) {
      site.querySelector(':scope > .home-fixed-header')?.remove();
      homeHeader.classList.add('page-header', 'home-fixed-header');
      site.insertBefore(homeHeader, site.querySelector('#main'));
    }
    fixedHeader = site?.querySelector(':scope > .landing-bar');
    updateFixedHeader();
    if (bottomNav) {
      if (landing && 'IntersectionObserver' in window) { heroObserver=new IntersectionObserver(entries=>bottomNav.classList.toggle('visible',entries[0].intersectionRatio<.08),{threshold:.08}); heroObserver.observe(landing); }
      else bottomNav.classList.add('visible');
    }
    if (!window.Shopify?.designMode && 'IntersectionObserver' in window && matchMedia('(prefers-reduced-motion: no-preference)').matches) {
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('shown');observer.unobserve(entry.target);}}),{rootMargin:'0px 0px 35px 0px',threshold:.08});
      document.querySelectorAll('[data-reveal]:not(.will-reveal)').forEach(el=>{el.classList.add('will-reveal');observer.observe(el);});
    }
  }
  setupSections();
  document.addEventListener('shopify:section:load',setupSections);
  document.addEventListener('shopify:section:unload',()=>requestAnimationFrame(setupSections));
})();
